
export const facets = {
  source: [{ type: "value", name: "site", size: 10 }],
  domains: [{ type: "value", name: "site", size: 10 }],
  categories: [{ type: "value", name: "category", size: 10 }],
  topics: [{ type: "value", name: "topics", size: 10 }],
  filetype: [{ type: "value", name: "file_type", size: 10 }],
  yearstr: [{ type: "value", name: "yearstr", size: 10 }],
  discipline: [{ type: "value", name: "discipline", size: 10 }],
};

//search queries search against all fields
export const search_fields = {
  title: {},
  meta_description: {},
  meta_keywords:{},
  body: {},
  categories: {}, 
  headings: {},
  discipline:{},
  topics:{}
};

export const result_fields = {
  title: {raw: {} , snippet: { size: 350, fallback: true } },
  meta_description: { snippet: { size: 350, fallback: true } },
  body: { snippet: { size: 350, fallback: true } },
  filetype: { raw: {} },
  url: { raw: {} },
  source: { raw: {} },
  discipline: { raw: {} },
  description: { snippet: { size: 350, fallback: true } },
  yearstr: { raw: {} },
  gated: { raw: {} },
  id: { raw: {} }
};


